import { Link } from 'react-router-dom';

const pillarArticles = [
  {
    title: 'What Is Basetao Spreadsheet?',
    description: 'A complete introduction to the Basetao Spreadsheet ecosystem — what it is, how it works, and why thousands of shoppers rely on it daily.',
    icon: 'ri-question-answer-line',
    link: '/what-is-basetao-spreadsheet',
    readTime: '8 min',
  },
  {
    title: 'How To Use Basetao Spreadsheet',
    description: 'Step-by-step walkthrough from navigation basics to advanced filtering. Master every feature of the spreadsheet in one comprehensive guide.',
    icon: 'ri-guide-line',
    link: '/how-to-use-basetao-spreadsheet',
    readTime: '9 min',
  },
  {
    title: 'Basetao Spreadsheet Tutorial',
    description: 'Hands-on tutorial covering categorization, QC analysis, cost calculation, and community best practices with practical examples.',
    icon: 'ri-book-read-line',
    link: '/basetao-spreadsheet-tutorial',
    readTime: '10 min',
  },
  {
    title: 'Basetao Review 2026',
    description: 'Unbiased assessment of platform features, pricing, shipping experience, and support quality. Pros, cons, and honest analysis.',
    icon: 'ri-star-line',
    link: '/basetao-review-2026',
    readTime: '8 min',
  },
  {
    title: 'Is Basetao Legit?',
    description: 'Thorough investigation into Basetao legitimacy, buyer protections, community verification, and safety best practices for new users.',
    icon: 'ri-shield-check-line',
    link: '/is-basetao-legit',
    readTime: '7 min',
  },
  {
    title: 'Basetao Shipping Cost Guide',
    description: 'Complete breakdown of shipping methods, real cost estimates by weight and destination, and proven consolidation strategies to save money.',
    icon: 'ri-ship-line',
    link: '/basetao-shipping-cost',
    readTime: '9 min',
  },
  {
    title: 'Basetao Coupon & Discount Guide',
    description: 'All active coupon codes, seasonal promotions, stacking strategies, and insider tips to maximize savings on every order in 2026.',
    icon: 'ri-coupon-3-line',
    link: '/basetao-coupon-guide',
    readTime: '7 min',
  },
  {
    title: 'Basetao Warehouse Guide',
    description: 'How the warehouse system works — storage periods, consolidation process, processing times, and best practices for efficient shipping.',
    icon: 'ri-store-2-line',
    link: '/basetao-warehouse-guide',
    readTime: '7 min',
  },
  {
    title: 'Basetao QC Guide',
    description: 'Master quality control photos — how to request, read, and act on QC images to ensure every purchase meets your expectations.',
    icon: 'ri-camera-line',
    link: '/basetao-qc-guide',
    readTime: '8 min',
  },
  {
    title: 'Basetao Beginner Guide',
    description: 'The ultimate first-timer walkthrough — account setup, first order tips, common terminology, and a complete first-month roadmap.',
    icon: 'ri-rocket-line',
    link: '/basetao-beginner-guide',
    readTime: '8 min',
  },
];

export default function PillarArticles() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-200 text-secondary-700 text-xs font-semibold uppercase tracking-wide mb-4">
            Pillar Articles
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Complete Basetao Knowledge Base
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Dive deep into every aspect of the Basetao Spreadsheet with our comprehensive pillar articles. Each guide is researched, detailed, and updated for 2026.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {pillarArticles.map((article) => (
            <Link
              key={article.link}
              to={article.link}
              className="group flex flex-col p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300 hover:bg-accent-50/20 transition-all duration-200 hover:-translate-y-0.5"
            >
              <div className="flex items-start gap-4 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 group-hover:bg-accent-200 flex-shrink-0 transition-colors">
                  <i className={`${article.icon} text-lg text-accent-600`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors leading-snug mb-1">
                    {article.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{article.readTime} read</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                {article.description}
              </p>
              <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-600 group-hover:text-accent-700 transition-colors mt-3">
                Read Article
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span>View All Guides</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}